import React from "react";
import Header from "../../components/header/HeaderDark";
import Slider from "../../components/slider/SliderDark";
import About from "../../components/about/AboutDark";
import Service from "../../components/service/Service";
import PortfolioAnimation from "../../components/portfolio/PortfolioAnimation";
import Testimonial from "../../components/testimonial/Testimonial";
import Blog from "../../components/blog/Blog";
import Contact from "../../components/Contact";
import Footer from "../../components/footer/Footer";
import Address from "../../components/Address";
import ExperienceAnimation from "../../components/experience/ExperienceAnimation";

const HomeDark = () => {
  document.body.classList.add("dark");
  return (
    <div className="home-dark">
      <Header />
      {/* End Header */}

      <Slider />
      {/* End Slider */}

      <div className="beny_tm_about" id="about">
        <div className="container">
          <div className="beny_tm_title_holder">
            <span>About Me</span>
            <h2>About Me</h2>
          </div>
          {/* End .beny_tm_title */}
          <About />
          {/* End Slider */}
        </div>
      </div>
      {/* /ABOUT */}

      {/* Experiences */}
      <div className="beny_tm_services" id="service">
        <div className="container">
          <div className="beny_tm_title_holder">
            <span>Experiences</span>
            <h2>Experiences</h2>
            <p>
              These are some awesome places I have worked with. I am working on
              the professional field for past 4 years
            </p>
          </div>
          {/* End beny_tm_title */}
          <ExperienceAnimation />
        </div>
      </div>
      {/* /Experiences */}

      {/* PORTFOLIO */}
      <div className="beny_tm_portfolio" id="portfolio">
        <div className="container">
          <div className="beny_tm_title_holder">
            <span>Portfolio</span>
            <h2>My Portfolio</h2>
            <p>Building Projects is fun!!</p>
          </div>
          {/* End beny_tm_title */}
          <PortfolioAnimation />
        </div>
      </div>
      {/* /PORTFOLIO */}

      {/*  CONTACT */}
      <div className="beny_tm_contact" id="contact">
        <div className="container">
          <div className="contact_inner">
            <div className="left">
              <div className="beny_tm_title_holder">
                <span>Contact</span>
                <h2>Let's discuss</h2>
              </div>
              <div className="short_list">
                <Address />
              </div>
            </div>
            {/* End .left */}
            <div className="right">
              <div className="title">
                <p>I'm always open to discuss Technologies</p>
              </div>
              <div className="fields">
                <Contact />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /CONTACT */}

      {/* COPYRIGHT */}
      <div className="beny_tm_copyright">
        <div className="container">
          <Footer />
        </div>
      </div>
      {/* /COPYRIGHT */}
    </div>
  );
};

export default HomeDark;
